import React, { useEffect, useState } from 'react'
import "./Calculator.scss";

import axios from "axios";
import { apiUrl } from '../../constants';
import useQuery from '../../components/useQuery'
import Swal from "sweetalert2";

const ComparisonModel = (props) => {
    const login_token = useQuery();
    const [token, settoken] = useState(login_token)
    const [data, setdata] = useState([])

    useEffect(() => {
        getModel()
    }, [])

    const getModel = () => {
        // console.log(apiUrl)
        var allData = []
        var allDataGroup = []
        var token_get = localStorage.getItem('token')
        var cover_token_get = JSON.parse(token_get)

        var app_version_data_get = localStorage.getItem('app_version')
        var app_version_data = JSON.parse(app_version_data_get)

        var device_type_data_get = localStorage.getItem('device_type')
        var device_type_data = JSON.parse(device_type_data_get)

        axios({
            method: "get",
            url: `${apiUrl}/model?app_version=${app_version_data}&device_type=${device_type_data}`,
            headers: {
                Accept: "application/json",
                Authorization: `Bearer ${cover_token_get}`,
            },
        }).then((res) => {

            if (res.data.checkSystem !== null) {
                window.location.href = `callback?is_force_update=${res.data.checkSystem.isForce}&msg=${res.data.checkSystem.message}&version=${res.data.checkSystem.version}&store_link=${res.data.checkSystem.storeLink}`
            }

            res.data.data.map((data, index) => {
                let group = res.data.data.filter(item => item.modelGroup === data.modelGroup)
                console.log(group[0].modelTypeName)
                let modelTypeName = group[0].modelTypeName != " " ? "("+group[0].modelTypeName+")" : group[0].modelTypeName
                if (group.length === 2) {
                    data = {
                        group: group,
                        pModelID1: group[0].id,
                        pModelID2: group[1].id,
                        modelGroup: group[0].modelGroup ? group[0].modelGroup : "",
                        name: modelTypeName + " " + group[0].name + ' - ' + group[1].name,
                    };
                    allData.push(data);
                }
            });

            const data_remove = allData.filter((item_data, index) => {
                const _item_data = JSON.stringify(item_data);
                return (
                    index ===
                    allData.findIndex((obj) => {
                        return JSON.stringify(obj) === _item_data;
                    })
                );
            });
            // console.log(data_remove)

            setdata(data_remove)
        }).catch((err) => {
            if (err.response.status === 401) {
                window.location.href = `callback?is_un_auth=${true}&msg=${err.response.data.message}`
            } else {
                Swal.fire("Error", `${err.response.data.message}`, "error");
            }
        })
    }


    const selectItem = (item) => {
        props.comparison_model_change(item)
        props.handleDisplayModal(!props.displayModal)
    }

    return (
        <div className="container">

            <fieldset className="my-fieldset" style={{ marginTop: "20px" }} onClick={() => props.handleDisplayModal(!props.displayModal)}>
                <legend className="my-legend">
                    Comparison model
                    </legend>

                <div className="d-flex justify-content-between" style={{ marginBottom: "20px", marginTop: "10px" }}>
                    <span style={{ marginLeft: "10px" }}>{props.comparison_model}</span>
                    <div style={{ marginRight: "10px" }}>
                        <svg width="7" height="12" viewBox="0 0 7 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M0.184424 11.8192C-0.0391203 11.6001 -0.0594426 11.2571 0.123458 11.0155L0.184424 10.9462L5.23006 6L0.184424 1.05377C-0.0391203 0.83462 -0.0594426 0.491687 0.123458 0.250032L0.184424 0.180798C0.407969 -0.0383512 0.75778 -0.0582738 1.00428 0.12103L1.0749 0.180798L6.56558 5.56351C6.78912 5.78266 6.80944 6.1256 6.62654 6.36725L6.56558 6.43649L1.0749 11.8192C0.829005 12.0603 0.430324 12.0603 0.184424 11.8192Z" fill="#200E32" />
                        </svg>
                    </div>

                </div>
            </fieldset>

            <div className={`Modal ${props.displayModal ? "Show" : ""}`}>
                <div style={{ marginTop: "10px" }}>
                    <h3>Comparison model</h3>
                </div>

                <button
                    className="Close"
                    onClick={() => props.handleDisplayModal(!props.displayModal)}
                >
                    X
                </button>
                <hr />

                {data.length > 0 ? data.map((item, key) => {
                    return (
                        <div key={key} className="container" onClick={() => selectItem(item)}>
                            <p>{item.name}</p>
                            <hr />

                        </div>
                    )
                }) : "No data"}
            </div>

            <div
                className={`Overlay ${props.displayModal ? "Show" : ""}`}
                onClick={() => props.handleDisplayModal(!props.displayModal)}
            />
        </div>

    )
}

export default ComparisonModel
